import { closeSnackbar, enqueueSnackbar, SnackbarMessage, VariantType } from 'notistack';
import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const dismiss = (key: any) => () => {
    closeSnackbar(key);
};

let isDisabled = 0;

export default {
    success(msg: string) {
        this.toast(msg, 'success');
    },
    info(msg: string) {
        this.toast(msg, 'info');
    },
    warning(msg: string) {
        this.toast(msg, 'warning', 0);
    },
    error(msg: string) {
        this.toast(msg, 'error', 0);
    },
    toast(msg: SnackbarMessage, variant: VariantType = 'default', duration = 5) {
        enqueueSnackbar(msg, {
            variant,
            autoHideDuration: duration ? duration * 1000 : null,
            style: { whiteSpace: 'pre-line' },
            action: (key) => <IconButton onClick={dismiss(key)}><CloseIcon sx={{ color: 'white' }} /></IconButton>,
        });
    },
    disableErrorToast() {
        isDisabled = new Date().getTime();
    },
    enableErrorToast() {
        isDisabled = 0;
    },
    isErrorToastEnabled() {
        // toast can only be disabled for 5 secs ( in case we somehow don't re-enable it)
        return isDisabled === 0 || isDisabled < new Date().getTime() - 5000;
    },
};
